import { FormikProps } from "formik";
import { Checkbox, Input, Modal } from "../../../components";
import { FormControlLabel } from "@mui/material";

interface DenyModalProps {
  denyModalVisibility: boolean;
  modalVisibilityControls: {
    setFalse: () => void;
  };
  formik: FormikProps<{ reason: string, send_email: boolean }>;
}

export const DenyBidsModal = ({ denyModalVisibility, modalVisibilityControls, formik }: DenyModalProps) => {
  return (
    <Modal
      open={denyModalVisibility}
      onClose={modalVisibilityControls.setFalse}
      title="Qual o motivo da recusa?"
      onConfirm={formik.handleSubmit}
      confirmLabel="Confirmar"
    >
      <div
        style={{
          width: 400,
        }}
      >
        <Input
          label="Motivo"
          name="reason"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.reason}
          helperText={formik.touched.reason && formik.errors.reason}
          error={!!formik.touched.reason && !!formik.errors.reason}
        />
        <FormControlLabel
            control={
                <Checkbox 
                    checked={formik.values.send_email}
                    onChange={event => {
                      formik.setFieldValue('send_email', event.target.checked);
                    }}
                    name="send_email" 
                />
            } 
            label="Enviar email" 
        /> 
      </div>
    </Modal>
  );
};
